/* --- Trigger button --- */

.trigger {
  align-items: center;
  background: var(--color-background, #ffffff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  gap: 8px;
  height: 32px;
  outline: none;
  padding: 0 14px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.trigger:hover {
  border-color: var(--color-foreground);
}

.trigger-is-open {
  border-color: var(--color-focus);
  box-shadow: 0 0 0 2px var(--color-focus);
}

.triggerIcon {
  color: var(--color-muted);
  flex-shrink: 0;
  height: 14px;
  width: 14px;
}

/* --- Portal-rendered panel --- */

.panel {
  background: var(--color-background, #ffffff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  /* Panel itself must NOT scroll/clip — MultiSelect option dropdowns
     are position:absolute children and we need them to spill outside
     the panel bounds. Each MultiSelect already caps its own option
     list at 320px and scrolls internally. */
  overflow: visible;
  position: fixed;
  z-index: 100;
}

.header {
  align-items: center;
  border-bottom: 1px solid var(--color-border, #e5e7eb);
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
}

.clearLink {
  background: none;
  border: none;
  color: var(--color-link, #2563eb);
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.clearLink:hover {
  color: var(--color-foreground);
}

.fields {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.fieldLabel {
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.footer {
  border-top: 1px solid var(--color-border, #e5e7eb);
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px;
}
